<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-dialog
      v-model="dialogAjoutBudget"
      width="90%"
      :persistent="true"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            > {{ typeEtat ? 'Modifier le budget pour la tâche ': 'Planifier budget pour les travaux'}} {{ typeTrx.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-form
            id="formBudget"
            :model="formBudget"
            :rules="rulesBudget"
            ref="formBudget"
            :label-position="labelPosition"
            class="demo-form-inline"
          >
            <v-layout wrap>
              <v-flex xs12>
                <v-layout row>
                  <v-flex md4 class="mr-1">
                    <el-form-item v-if="!typeEtat"
                      prop="tache"
                      label="Tache"
                      fil
                      required
                      style="width:100%"
                    >
                      <el-select
                        name="valeurSelect"
                        clearable
                        id="valeurSelect"
                        v-model="formBudget.tache"
                        v-on:change="loadTypeBudeget()"
                        placeholder="Sélectionner une tache"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listaches"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item v-if="typeEtat"
                      prop="tache"
                      label="Tache"
                      required
                      filterable
                      style="width:100%"
                    >                      
                    <el-input
                        style="font-size:22px"
                        :value=" typeTrx.libelle"
                        v-model=" typeTrx.libelle"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </v-flex>

                  <v-flex md4 class="mr-1" >
                    <el-form-item
                      prop="tache"
                      label="Date de debut"
                      required
                      style="width:100%"
                    >                      
                    <el-input v-if="typeEtat"
                        style="font-size:22px"
                        :value="typeTrx.dateD"
                        v-model="typeTrx.dateD"
                        disabled
                      ></el-input>

                      <el-input v-if="!typeEtat"
                        style="font-size:22px"
                        :value="tableDate.dateD"
                        v-model="tableDate.dateD"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </v-flex>

                  <v-flex md4 class="mr-1">
                    <el-form-item
                      prop="tache"
                      label="Date de fin"
                      required
                      style="width:100%"
                    >
                    <el-input v-if="typeEtat"
                        style="font-size:22px"
                        :value="typeTrx.dateF"
                        v-model="typeTrx.dateF"
                        disabled
                      ></el-input>
                      
                      <el-input v-if="!typeEtat"
                        style="font-size:22px"
                        :value="tableDate.dateF"
                        v-model="tableDate.dateF"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </v-flex>
                
                </v-layout>
                <v-layout row>
                  <v-flex md3 class="mr-1">
                    <el-form-item
                      prop="ressource"
                      label="Type de ressource"
                      required
                      style="width:100%"
                    >
                    <el-select
                        v-model="formBudget.ressource"
                        filterable
                        v-on:change="loadUniteProduit(formBudget.ressource)"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listeProduitAffich"
                          :key="item.id"
                          :id="item.id"
                          :label="item.value+' / '+item.type"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <v-tooltip bottom>
                        <v-btn class="elevation-3" slot="activator" @click="loadProduit()" dark icon flat color="primary">
                            <v-icon>cached</v-icon>
                        </v-btn>
                        actualiser la liste
                    </v-tooltip>
                  </v-flex>

                  <v-flex md3 class="mr-1">
                    <el-form-item
                      prop="valeurCodeAnalytique"
                      label="Code analytique"
                      filterable
                      style="width:100%"
                    >      
                    <el-input type="text" name="valeurCodeAnalytique" v-model="valeurCodeAnalytique"  style="font-size:22px"></el-input>                                     
                    </el-form-item>
                  </v-flex>
                  <v-flex md3 class="mr-1">
                    <el-form-item
                      prop="valeurCodeGestion"
                      label="Code gestion"
                      filterable
                      style="width:100%"
                    >      
                    <el-input type="text" name="valeurCodeGestion" v-model="valeurCodeGestion"  style="font-size:22px"></el-input>                                     
                    </el-form-item>
                  </v-flex>

                  <v-flex md3 class="mr-1">
                    <el-form-item
                      prop="unite"
                      label="Unité"
                      style="width:100%"
                    >
                     <el-input type="text" name="valeurSelect" :readonly="true" v-model="valeurUniteMateriel" style="width:100%"></el-input>
              
                    </el-form-item>
                  </v-flex>                
                </v-layout>
                <v-layout row> 
                  <v-flex md3 class="mr-1">
                    <el-form-item
                      prop="qte"
                      label="Quantité "
                      required                    
                      style="width:100%"
                    >
                      <el-input-number
                        style="font-size:22px"
                        @change="calculMontant(formBudget)"
                        controls-position="right"
                        v-model="formBudget.qte"
                        :min="0"
                      ></el-input-number>
                    </el-form-item>
                  </v-flex>

                  <v-flex md3 class="mr-1">
                    <el-form-item
                      prop="prix"
                      label="Prix unitaire "
                      required
                      style="width:100%"
                    >
                      <el-input-number
                        style="font-size:22px"
                        @change="calculMontant(formBudget)"
                        controls-position="right"
                        v-model="formBudget.prix"
                        :min="0"
                      ></el-input-number>
                    </el-form-item>
                  </v-flex>

                  <v-flex md3 class="mr-1">              
                    <el-form-item
                      prop="total"
                      label="Montant total"
                      style="width:100%"
                    >
                    <el-input type="text" style="font-size:22px" name="montantTotal" :readonly="true" v-model="montantTotal"></el-input>

                    </el-form-item>
                  </v-flex>
            
                  <v-flex md3 class="mr-1">
                    <el-form-item label="action" style="width:100%">
                      <el-button
                        type="primary"
                        :disabled="!verifFormBudget"
                        @click="addListBudget(formBudget)"
                        >Ajouter</el-button
                      >
                    </el-form-item>
                  </v-flex>
                </v-layout>

                <v-flex xs12 class="text-xs-right">
                  <v-tooltip top>
                    <input
                      name="fileInputExcel"
                      type="file"
                      style="display:none"
                      ref="fileInputExcel"
                      accept="image/*"
                      v-on:change="onFileExcelPicked"
                    />
                    <v-btn
                      v-if="true"
                      slot="activator"
                      color="green"
                      @click.stop="$refs.fileInputExcel.click()"
                      dark
                    >
                      Importer
                      <v-icon right>file_download</v-icon> </v-btn
                    >Importer fichier excel
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      v-if="true"
                      slot="activator"
                      color="orange"
                      @click.stop="dialogImport = true"
                      dark
                    >
                      Générer
                      <v-icon right>file_upload</v-icon> </v-btn
                    >Générer un modèle
                  </v-tooltip>
                </v-flex>

                <v-layout row>
                  <v-flex xs12>
                    <el-table :data="tableBudget" style="width: 100%" v-if="typeEtat" >                     
                      <el-table-column prop="ressource" label="Type de ressource" sortable>
                      </el-table-column>  
                      <el-table-column prop="codeAnalytique" label="Code analytique" sortable>
                      </el-table-column>  
                      <el-table-column prop="codeGestion" label="Code de gestion" sortable>
                      </el-table-column>                     
                      <el-table-column prop="unite" label="Unité" sortable>
                      </el-table-column>
                      <el-table-column prop="qte" label="Quantité" sortable>
                      </el-table-column>
                      <el-table-column prop="prix" label="Prix Unitaire" sortable>
                      </el-table-column>
                      <!-- <el-table-column prop="total" label="Montant total" sortable>
                      </el-table-column> -->
                      <el-table-column prop="total" label="Montant total">
                        <template slot-scope="scope">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.montant
                            )
                          }}
                        </template>
                      </el-table-column>

                      <el-table-column label="Operations">
                        <template slot-scope="scope">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              fab
                              small
                              icons
                              color="red"
                              @click.native.prevent="
                                deleteRow(scope.$index, tableBudget)
                              "
                              dark
                            >
                              <v-icon center>delete</v-icon>
                            </v-btn>
                            Supprimer
                          </v-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table :data="tableBudget" style="width: 100%" v-if="!typeEtat" >
                      <!-- <el-table-column prop="libelle" label="Tache" >
                      </el-table-column> -->
                      <el-table-column prop="ressource" label="Type de ressource" sortable>
                      </el-table-column>                     
                      <el-table-column prop="codeAnalytique" label="Code analytique" sortable>
                      </el-table-column>  
                      <el-table-column prop="codeGestion" label="Code de gestion" sortable>
                      </el-table-column>    
                      <el-table-column prop="unite" label="Unité" sortable>
                      </el-table-column>
                      <el-table-column prop="qte" label="Quantité" sortable>
                      </el-table-column>
                      <el-table-column prop="prix" label="Prix Unitaire" sortable>
                      </el-table-column>
                      <!-- <el-table-column prop="total" label="Montant total" sortable>
                      </el-table-column> -->
                      <el-table-column prop="total" label="Montant total">
                        <template slot-scope="scope">
                          {{
                            new Intl.NumberFormat().format(
                              scope.row.montant
                            )
                          }}
                        </template>
                      </el-table-column>

                      <el-table-column label="Operations">
                        <template slot-scope="scope">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              fab
                              small
                              icons
                              color="red"
                              @click.native.prevent="
                                deleteRow(scope.$index, tableBudget)
                              "
                              dark
                            >
                              <v-icon center>delete</v-icon>
                            </v-btn>
                            Supprimer
                          </v-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </el-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click.native="closeDialog()"
            >Annuler</v-btn
          >
          <v-btn
            color="green darken-1"
            flat="flat"
            v-if="formBudget.tache != ''"
            @click.native="createBudget()"
            >Enregistrer</v-btn
          >
          <v-btn
            color="green darken-1"
            flat="flat"
            v-if="typeEtat"
            @click.native="createBudget()"
            >Enregistrer</v-btn
          >

          
        </v-card-actions>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <LoadTypeBudgetExcel
      @close="
        showModalLoadBudget = false;
        loadListeTravaux();
        closeDialog();
      "
      :show="showModalLoadBudget"
      :idChantier="idChant"
      :typeTrx="this.typeTrx.id"
      :listeTypeTravaux="lstBudget"
    ></LoadTypeBudgetExcel>


      <!-- MODAL IMPORTATION STOCK -->
  <v-dialog v-model="dialogImport" max-width="50%" :overlay="true" scrollable persistent>
    <v-card>
      <v-card-text text-xs-center>
        <h4 align="center">Nb: Le fichier contient uniquement les ressources qui figurent dans votre base de produit.</h4>
        <h4 align="center">Indiquer uniquement la QUANTITE et le PRIX UNITAIRE de chaque ligne de produit que vous souhaitez ajouter pour élaborer votre budget.</h4>
        <h3 align="center">Supprimer ensuite les lignes restantes dans votre fichier avant importation.</h3>
        <p align="center">
          <v-btn @click.native="dialogImport = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
          <v-btn icons color="green" @click.stop="generateFileExcel()" dark>Généner <v-icon right>done</v-icon></v-btn>
        </p>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>

  </div>
</template>

<script>
//function de difference de date

var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import html2canvas from "html2canvas";
import Loading from "@/components/Loading";
import LoadTypeBudgetExcel from "@/components/boardChantier/loadBudget.vue";

export default {
  components: {
    Loading,
    LoadTypeBudgetExcel
  },
  props: {
    typeEtat: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
    typeTrx: {
      type: Object
    },
    idChant: {
      type: Number
    }
  },
  name: "AjoutPrevisionBudgetChantier",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,

      //VARIABLE
      dialogAjoutBudget: false,
      dialogImport: false,
      IdTypeSelct: "",
      formBudget: {
        dateMoisAn: null,
        unite: null,
        ressource: "",
        libelle: "",
        tache: "",
        valeurCodeGestion:'',
        valeurCodeAnalytique:'',
        qte: "",
        prix: "",
        montant: 5
      },
      rulesBudget: {
        // dateMoisAn: [{ required: true, message: "Veuillez selectionner" }],
        libelle: [{ required: true, message: "Veuillez selectionner" }],
        ressource: [{ required: true, message: "Veuillez selectionner" }],
        qte: [{ required: true, message: "Veuillez selectionner" }],
        prix: [{ required: true, message: "Veuillez selectionner" }]
      },
      datePickerRtp: {
      },
      valeurUniteMateriel: "",
      valeurCodeAnalytique: "",
      valeurCodeGestion: "",
      montantTotal:0,
      showModalLoadBudget: false,

      //Importer fichier excel
      fileExcel: [],
      lstBudget: [],
      listaches: [],
      listeBudgetSupp: [],

      listeProduitBudget: [],
      listeProduitAffich: [],
      listProduit: [],
      tableBudget: [],
      tableDate: [],
      tableOptTrav: [],
      listTypeRessource: [],
      labelPosition: "top"
    };
  },
  computed: {
    verifFormBudget: function() {
      console.log("typeEtat",this.typeEtat)
      if(this.typeEtat){
        return true;
      }else {
        if (
        // this.formBudget.dateMoisAn != null &&
        this.formBudget.tache != "" &&
        this.formBudget.qte != "" &&
        this.formBudget.ressource != "" &&
        this.formBudget.prix != "" &&
        this.formBudget.tache != ""
      ) {
        return true;
      } else {
        return false;
      }
      }  
    }
  },
  watch: {
    show: function(newValue, oldValue) {
      console.log('newValue',newValue, this.typeTrx);
      
      if (newValue == true) {
        let _this = this;
        this.listeBudgetSupp = [];
        _this.loadListeTravaux();
        this.tableBudget.splice(0);
        let detailBudget = this.typeTrx.detailBudget ? this.typeTrx.detailBudget : [];
        this.listaches = this.typeTrx.taches;
        console.log('detailBudget',detailBudget)
        this.tableOptTrav = detailBudget
          if(detailBudget.length >0) {
            detailBudget.forEach(item => {
              console.log('item ic',item)   
              this.tableBudget.push(item);
            });
          }

        this.dialogAjoutBudget = true;
        // this.loadTypeRessource();
        // this.loadProduitBudget();
        this.loadProduit()
        this.formBudget = {
          libelle: "",
          qte: 0,
          prix: 0,
          total: 0 ,
          ressource: "",
          tache: ""
        };
      } else {
        this.dialogAjoutBudget = false;
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs["formBudget"].resetFields();
    },
    loadTypeBudeget() {
      this.loading = true;
      let url =
        this.domaine +
        "budgetChantier/tache/" +
        this.formBudget.tache.id +
        "/" +
        this.typeTrx.sous +
        "/" +
        this.idChant
        +'/'+
        this.typeTrx.idTravaux;
      this.$http.get(url).then(
        response => {   
          this.tableBudget = response.body.taches["detail"] ?  response.body.taches["detail"] : [];
          this.tableDate = response.body.taches;
          this.tableOptTrav = response.body.optTravaux;
          this.loading = false;         
        },
        errRep => {
          this.loading = false;
        }
      );
    },
    loadTypeRessource() {
      let url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listTypeRessource = response.body.types;
          this.loading = false;
        }
      });
    },
    deleteRow(index, rows) {
      // enregistrer lid du lot de travaux supprimer dans la liste
      this.listeBudgetSupp.push(this.tableBudget[index]);
      rows.splice(index, 1);
    },
    calculMontant(item) {
      console.log('item',item)
      let prix = item.prix ? item.prix :  0
      let qte = item.qte ? item.qte :  0
      let calcul =  qte * prix

      this.montantTotal = calcul

      console.log('montantTotal',this.montantTotal)

    },
    loadUniteProduit(item) {
        this.valeurUniteMateriel =''
        this.valeurTypeUniteMateriel =''
        this.valeurCodeAnalytique = ''
        this.valeurCodeGestion = ''
        this.codegestion = item.codeGestion
        this.valeurTypeUniteMateriel = item.type
        this.valeurUniteMateriel = item.unite;
        this.valeurCodeAnalytique = item.codeAnalytique;
        this.valeurCodeGestion = item.codeGestion;
        this.formBudget.prix = item.valeur
    },
    loadTypeProduit() {
      this.loading = true;
      this.listeProduitBudget = [];
      if (this.formBudget.ressource != 0) {
        let url =
          this.domaine +
          "product/productSelect/type/" +
          this.formBudget.ressource;
        this.$http.get(url).then(
          response => {
            this.loading = false;
            this.listeProduitBudget = response.body.produits;
            this.listeProduitAffich = response.body.produits;
          },
          errRep => {
            this.loading = false;
            this.$message.error(
              "Une erreur est survenue lors du chargement de la liste du chntier"
            );
          }
        );
      } else {
        this.loadProduitBudget();
        this.loading = false;
      }
    },
    loadProduit() {
        let url = "";
        this.loading = true;
        url = this.domaine + "product/product-list";
        this.$http.get(url).then(response => {
          if (response.body) {
          this.loading = false;
            this.listProduit = response.body;
            this.listeProduitAffich = response.body;
          }
        });
      },

    loadListeTravaux() {
      this.loading = true;
      let url = this.domaine + "budgetChantier/chantier/" + this.idChant;
      this.$http.get(url).then(
        resp => {
          this.loading = false;
          this.tableListeTrxBudget = resp.body.listeTypeTrx;
          this.totalMntPropose = resp.body.totalMntPropose;
          this.totalMntValide = resp.body.totalMntValide;
          this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation"
          );
        }
      );
    },
    closeFormTypeProduit() {
      this.showModalLoadBudget = false;
      this.loadProduitBudget();
    },
    handleFileExcel(
      command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0": //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1": //generer un modele un fichier
          this.generateFileExcel();
          break;
        default:
          this.$refs.fileInputExcel.click();
          break;
      }
    },
    generateFileExcel() {
      this.dialogImport = false
      let url = this.domaine + "projet/generer/budget/modele";
      window.open(url);
    },
    onFileExcelPicked(event) {
      this.fileExcel.splice(0, 1);
      // this.showModalLoadBudget = true;
      // this.dialogAjoutBudget = false;
      this.loading = true;

      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);

      let url = this.domaine + "projet/loadBudget/excel";
      let data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;
          this.$notify({
            title: "Chargement liste des budgets",
            message: "Chargement effectué",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.tableBudget = resp.body.listeTypeTravaux;
          console.log('this.tableBudget',this.tableBudget)
          // this.showModalLoadBudget = true;
        },
        error => {
          this.loading = false;
          this.$message.error("Erreur lors de l'importation du fichier");
        }
      );
    },

    loadProduitBudget() {
      this.loading = true;
      let url = this.domaine + "budgetProjet/liste";

      this.listeProduitBudget.splice(0);
      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.loading = false;
            this.listeProduitBudget = response.body.produits;
          }
        },
        response => {
          this.loading = false;
        }
      );
    },

    addListBudget(item) {
      console.log('item',item)
      console.log('ressource',this.formBudget.ressource)
      let produit = this.formBudget.ressource
      //verifier si l'item n'et pas deja enregistrer dans le tableau
      if (this.tableBudget.length > 0) {
        let eltProd = this.tableBudget.find(
          elt =>
            elt.idProd == produit.idprod 
        );
        if (eltProd != null) {
          this.$message.error("Cette ressource a déjà été ajouté à la liste");
          return;
        }
      }
      console.log('item',item)
      this.tableBudget.push({        
        libelle: item.tache.libelle,
        codeAnalytique: this.valeurCodeAnalytique,
        codeGestion: this.valeurCodeGestion,
        idTache: item.tache.id,
        idProd: produit.idprod,
        ressource: item.ressource.value,
        prix: item.prix,
        qte: item.qte,
        montant: this.montantTotal,
        unite: item.ressource.unite
        // dateMoisAn: item.dateMoisAn
      });
      this.valeurUniteMateriel = "";
      this.valeurCodeAnalytique = ''
      this.valeurCodeGestion = ''
      this.montantTotal = 0
      this.formBudget.libelle = "";
      this.formBudget.qte = 0;
      this.formBudget.prix = 0;
      this.formBudget.montant = 0;
      this.formBudget.ressource = "";
      this.formBudget.unite = "";
      this.formBudget.dateMoisAn = "";
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
    format(percentage) {
      return `${percentage}%`;
    },

    getSumm(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    closeDialog() {
      this.$emit("close");
    },

    createBudget() {
      this.loading = true;
      let url = this.domaine + "budgetChantier/create/" + this.idChant;
      let nbData = 10;
      let nbReq = 1;
      let ligne = null;
      let nbRest;
      if (this.tableBudget.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.tableBudget.length / nbData);
        nbRest = this.tableBudget.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }

      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.tableBudget.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.tableBudget[j] == undefined) {
              break;
            }
            dataLot.push(this.tableBudget[j]);
          }
        }
        let data = new FormData();

        for (let prop in dataLot) {
          ligne = dataLot[prop];
          console.log('ligne',ligne)
          data.append("option[annee][]", ligne.dateMoisAn);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[unite][]", ligne.unite);

          data.append("option[tacheId][]", ligne.idTache);
          data.append("option[idProd][]", ligne.idProd);
          data.append("option[ressource][]", ligne.ressource);
          data.append("option[qte][]", ligne.qte);
          data.append("option[prix][]", ligne.prix);          
          data.append("option[montant][]", ligne.montant);
        }

        data.append("listBudget", JSON.stringify(this.listeBudgetSupp));
        data.append("typeTravauxId", this.typeTrx.id);
         console.log('data',this.formBudget.tache.id)
        data.append("tacheId", this.typeEtat ? this.typeTrx.id : this.formBudget.tache.id);
        data.append("idTravaux", this.typeTrx.idTravaux);
        data.append("optTravaux", this.tableOptTrav);
        data.append("typeDtravaux", this.tableOptTrav);
        data.append("etatModif", this.typeEtat);
        // data.append("dateD", this.typeTrx.dateD);
        // data.append("dateF", this.typeTrx.dateF);
        
        data.append("userId", this.user.id);
        data.append("nbSous", this.typeTrx.sous);

        this.$http.post(url, data).then(
          resp => {
            // this.$message.error("Veuillez patienter, cette fonctionnalité sera fonctionnelle dans quelques instants.");
            this.closeDialog();
            this.tableBudget.splice(0);
            this.loading = false;
            this.$notify({
              title: "Budget",
              message: "Budget enregistre avec succes",
              type: "success",
              position: "top-right",
              duration: 7000
            });
          },
          error => {
            this.loading = false;
            this.$message.error("Erreur lors de l'enregistrement des budjets");
          }
        );
      }
    }
  },

  mounted() {}
};
</script>

<style>
tr td.el-table__expanded-cell {
  background-color: #eeeeee;
}

td.el-table__expanded-cell div {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/boardChantier/AjoutPrevisionBudgetChantier.vue